
  __webpack_public_path__ = window.__FABRICS__.PUBLIC_PATH.register
  import('./register-bootstrap.js')
  